import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  presentation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  modalPresentation: {
    outline: 'none',
  },
  sectionBody: {
    padding: `${spacing.xsmall} ${spacing.xsmall} 0 ${spacing.xsmall}`,
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: 'rgba(0, 0, 0, 1)',
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: '1280px',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  headerIcon: {
    cursor: 'pointer',
    color: 'white',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cellData: {
    textDecoration: 'underline',
    textDecorationColor: colors.primary,
    color: colors.primary,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  evidences: {
    marginBottom: '67px',

    '& > img': {
      height: '32vw',
      objectFit: 'contain',
    },
  },
  footer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
});

export default useStyles;
